import React from 'react';
import { Box, Container, Typography, Accordion, AccordionSummary, AccordionDetails, Paper } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import PublicPageHeader from '../components/PublicPageHeader';

const faqs = [
  {
    question: 'What age is Earn-E appropriate for?',
    answer: 'Earn-E is designed for children ages 6–17. Children under 13 are protected by our COPPA-compliant privacy practices, which require parental consent.',
  },
  {
    question: 'Is Earn-E free to use?',
    answer: 'Earn-E offers a free tier with core features. Premium plans unlock advanced features like analytics, unlimited chores, and custom rewards.',
  },
  {
    question: 'What platforms is Earn-E available on?',
    answer: 'Earn-E is available as a web app, and on Android (Google Play) and iOS (App Store). All platforms sync in real time.',
  },
  {
    question: 'Can I cancel my subscription anytime?',
    answer: 'Yes, you can cancel your subscription at any time from your account settings. You\'ll retain access until the end of the billing period.',
  },
  {
    question: 'How many children can I add?',
    answer: 'Free plans support up to 2 children. Premium plans allow unlimited children in a family group.',
  },
  {
    question: 'Do kids need their own email address?',
    answer: 'For children under 13, parents can create a managed account without a separate email. Older children can sign up with their own email.',
  },
  {
    question: 'What is COPPA and how does Earn-E comply?',
    answer: 'COPPA is the Children\'s Online Privacy Protection Act. Earn-E collects only necessary data, requires parental consent for children under 13, and never shares data with advertisers.',
  },
];

const FAQPage = () => {
  return (
    <Box sx={{ minHeight: '100vh', backgroundColor: 'background.default' }}>
      <PublicPageHeader title="FAQ" />
      <Container maxWidth="md" sx={{ py: 4, px: { xs: 2, sm: 3 } }}>
        <Typography 
          variant="h1" 
          component="h2" 
          gutterBottom 
          fontWeight="bold" 
          textAlign="center" 
          sx={{ 
            fontSize: { xs: '1.4rem', sm: '1.7rem', md: '2.5rem' },
            lineHeight: 1.2,
            wordBreak: 'break-word'
          }}
        >
          Frequently Asked Questions
        </Typography>
        <Typography 
          variant="subtitle1" 
          textAlign="center" 
          color="text.secondary" 
          sx={{ 
            mb: 4,
            fontSize: { xs: '0.9rem', sm: '1rem' },
            px: { xs: 1, sm: 0 }
          }}
        >
          Everything you need to know about Earn-E Chore Helper.
        </Typography>
        <Paper elevation={2} sx={{ borderRadius: 3, overflow: 'hidden' }}>
          {faqs.map((faq, index) => (
            <Accordion 
              key={index} 
              disableGutters
              sx={{
                '&:before': { display: 'none' },
                '&.Mui-expanded': {
                  margin: '0 auto',
                  minHeight: 48
                }
              }}
            >
              <AccordionSummary 
                expandIcon={
                  <ExpandMoreIcon 
                    sx={{ 
                      color: '#4CAF50',
                      transition: 'transform 0.3s',
                      '&.Mui-expanded': {
                        transform: 'rotate(180deg)'
                      }
                    }}
                  />
                }
                aria-controls={`faq-panel-${index}`}
                id={`faq-header-${index}`}
                sx={{
                  minHeight: 56,
                  px: 2,
                  bgcolor: 'rgba(76, 175, 80, 0.04)',
                  borderBottom: '1px solid rgba(0,0,0,0.12)',
                  '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
                    transform: 'rotate(180deg)'
                  },
                  '& .MuiAccordionSummary-expandIconWrapper': {
                    color: '#4CAF50'
                  },
                  '&:hover': {
                    bgcolor: 'rgba(76, 175, 80, 0.08)'
                  }
                }}
              >
                <Typography 
                  fontWeight="medium"
                  sx={{
                    fontSize: { xs: '0.95rem', sm: '1rem' },
                    color: '#2E7D32'
                  }}
                >
                  {faq.question}
                </Typography>
              </AccordionSummary>
              <AccordionDetails 
                sx={{ px: 3, py: 2 }}
                id={`faq-panel-${index}`}
                aria-labelledby={`faq-header-${index}`}
              >
                <Typography 
                  color="text.secondary"
                  sx={{
                    fontSize: { xs: '0.9rem', sm: '1rem' },
                    lineHeight: 1.6
                  }}
                >
                  {faq.answer}
                </Typography>
              </AccordionDetails>
            </Accordion>
          ))}
        </Paper>
      </Container>
    </Box>
  );
};

export default FAQPage;
